var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_manager_2522727",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.66,
    height: 21.579,
    viewBox: "0 0 19.66 21.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    d: "M35.64,68.06c.447-.089.775-.536.984-1.222v-.06c.209-1.55-.179-3.13-1.252-3.815a16.578,16.578,0,0,0-4.292-1.818.2.2,0,0,0-.238.119l-1.609,4.679a.2.2,0,0,1-.358.03l-1.311-2.355a.222.222,0,0,1,.03-.268c1.639-1.52.924-2.8-.745-2.951h-.03c-1.669.149-2.355,1.4-.745,2.951a.222.222,0,0,1,.03.268l-1.311,2.355a.2.2,0,0,1-.358-.03l-1.609-4.679a.2.2,0,0,0-.238-.119,15.792,15.792,0,0,0-4.262,1.818c-1.073.686-1.46,2.265-1.252,3.815v.03c.209.686.507,1.133.984,1.252l.03.03h17.5A.092.092,0,0,1,35.64,68.06Zm-4.322-2.384,1.58-.835a.362.362,0,0,1,.387.03l1.1.775h-3.07Z",
    transform: "translate(-17.018 -46.511)",
    fill: "#2580ec"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3496",
    "data-name": "Path 3496",
    d: "M33.044,24.321c.089.119.179.268.328.447a.411.411,0,0,1,.089.119h0c.03.03.06.06.06.089a.029.029,0,0,1,.03.03,5.914,5.914,0,0,0,2.027,1.609,3.509,3.509,0,0,0,3.785-.447,6.9,6.9,0,0,0,1.848-2.235,9.757,9.757,0,0,0,1.252-4.053,5.6,5.6,0,0,0-5.305-6.05c-.03,0-.03-.03-.06-.03h0a5.691,5.691,0,0,0-3.636,1.222,5.615,5.615,0,0,0-1.967,5.067,9.939,9.939,0,0,0,1.55,4.232Zm-.209-3.964a.128.128,0,0,1,.119-.119A3.03,3.03,0,0,0,35.4,18.062a.14.14,0,0,1,.238-.03c1.192,1.639,2.5,2.355,5.6,2.235.06,0,.149.06.149.119a6.555,6.555,0,0,1-.775,3.636A5.021,5.021,0,0,1,37.9,26.437a2.052,2.052,0,0,1-.954.089,4.327,4.327,0,0,1-2.772-1.609A6.42,6.42,0,0,1,32.835,20.357Z",
    transform: "translate(-27.148 -13.8)",
    fill: "#2580ec"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducatorIcon);
export default __webpack_public_path__ + "static/media/educator-icon.c483536f497b295f8f750fab6b621b54.svg";
export { ForwardRef as ReactComponent };